import Fbtrack from 'react-facebook-pixel';

import { getQueryStrings } from '../shared/QueryParams';
import { TrackerType } from '@/actions/tracking/TrackerType';
import { EnsFieldsReducer } from '@/reducer/ensfields';
import { getPresetId } from '@/actions/shared/getPresetId';

const fbTracker: TrackerType = (event, dispatch) => {
  dispatch((_, getState: RootStateGetter) => {
    const state = getState();

    let knownEventName = '';

    switch (event.name) {
      case 'initApp':
        knownEventName = 'ViewContent';
        break;
      case 'ensuranceListSelection':
        knownEventName = 'CustomizeProduct';
        break;
      case 'onPersonalInput':
        knownEventName = 'initiateCheckout';
        break;
      case 'insuranceBooked':
        knownEventName = 'Purchase';
        break;

      case 'offerMailProcessSubmit':
        // 8.8.2023 Auf Anfrage von Thomas deaktiviert
        //case 'angebotAnforderungSubmit':
        knownEventName = 'Lead';
    }

    if (getQueryStrings()?.consoleTrack) console.log('Track FB event (custom)', event.name);
    Fbtrack.trackCustom(event.name, event.data || {});

    // Purchase event is only for the following presetsId
    // https://app.asana.com/0/1174272655772669/1204969351492285/f
    if (knownEventName === 'Purchase') {
      const presetId = getPresetId(state.ensPreset.ensPreset);

      if (
        ![
          '6543c1ba0edec2.72506626',
          '6543c1bac3e910.84378015',
          '6543c1bb890e97.48813889',
          '6543c1bc4db157.23241550',
          '6543c1bd0f11a3.99657205',
          '6543c1bdc66bd2.55401734',
          '6543c1be8cde94.3986475',
        ].includes(presetId)
      )
        return;
    }

    if (getQueryStrings()?.consoleTrack && knownEventName) console.log('Track FB event', knownEventName);
    if (knownEventName) Fbtrack.track(knownEventName, event.data || {});
  });
};

fbTracker.onInit = (endFields: EnsFieldsReducer) => {
  if (!endFields.ens_fb_tracking_id) return;
  Fbtrack.init(endFields.ens_fb_tracking_id, undefined, {
    autoConfig: true,
    debug: false,
  });
  Fbtrack.pageView();
};

export default fbTracker;
